import { Controller } from "@hotwired/stimulus"

// Company search controller for filtering feature flags admin table
export default class extends Controller {
  static targets = [ "input", "row", "tbody", "noResults" ]

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()
    let visibleCount = 0

    this.rowTargets.forEach(row => {
      const companyName = row.dataset.companyName
      const matches = companyName.includes(query)

      if (matches) {
        row.classList.remove("hidden")
        visibleCount++
      } else {
        row.classList.add("hidden")
      }
    })

    // Show/hide "no results" message
    if (visibleCount === 0) {
      this.noResultsTarget.classList.remove("hidden")
      this.tbodyTarget.classList.add("hidden")
    } else {
      this.noResultsTarget.classList.add("hidden")
      this.tbodyTarget.classList.remove("hidden")
    }
  }
}
